class FrequentlyBought extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		const checkboxes = this.querySelectorAll('.frequent-DescContainer-details .product-description-input input[type="checkbox"]');
		const frequentButton = this.querySelector('.frequentPrice-Button button');

		checkboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', () => this.handleCheckboxChange(checkbox, checkboxes));
		});

		if (frequentButton) {
			frequentButton.addEventListener('click', () => this.addToCart());
		}
	}

	handleCheckboxChange(checkbox, checkboxes) {
		const productId = checkbox.id.replace('product_', '');
		const descContainer = this.querySelector('#descContainer_' + productId);

		if (checkbox.checked) {
			descContainer.classList.remove('frequentHidden');
			descContainer.classList.add('frequentBlock');
			descContainer.setAttribute('data-visible', 'visible');
		} else {
			descContainer.classList.add('frequentHidden');
			descContainer.classList.remove('frequentBlock');
			descContainer.setAttribute('data-visible', 'invisible');
		}

		let totalPrice = 0;
		const visibleItems = this.querySelectorAll('.frequent-DescContainer .frequent-images[data-visible="visible"]');

		visibleItems.forEach((image) => {
			const price = parseFloat(image.getAttribute('data-frequentprice')) || 0;
			totalPrice += price;
		});

		this.querySelector('.frequent-originalPrice').innerHTML = totalPrice;

		const allUnchecked = Array.from(checkboxes).every(c => !c.checked);
		const atLeastOneUnchecked = Array.from(checkboxes).some(c => !c.checked);
		const allChecked = Array.from(checkboxes).every(c => c.checked);

		const priceButton = this.querySelector('.frequentPrice-Button');
		const offerPriceElement = priceButton.querySelector('.frequent-offerPrice');
		const originalPriceElement = priceButton.querySelector('.frequent-originalPrice');
		const higherPrice = priceButton.getAttribute('data-higher-price');

		const button = priceButton.querySelector('button');

		if (allChecked) {
			button.innerHTML = `Add To Cart : <span>
				<span class="frequent-originalPrice offer-lineThrough">Rs. ${totalPrice}</span>
			</span>
			<span class="frequent-offerPrice">Rs. ${higherPrice}</span>`;
		}

		if (atLeastOneUnchecked) {
			offerPriceElement.style.display = 'none';
			originalPriceElement.classList.remove('offer-lineThrough');
		} else {
			offerPriceElement.style.display = 'inline-block';
			originalPriceElement.classList.add('offer-lineThrough');
		}

		if (allUnchecked) {
			button.style.opacity = '0.5';
			button.style.pointerEvents = 'none';
		} else {
			button.style.opacity = '1';
			button.style.pointerEvents = 'auto';
		}
	}

	addToCart() {
		const visibleItems = this.querySelectorAll('.frequent-DescContainer .frequent-images[data-visible="visible"]');
		const variantIds = [], names = [], prices = [], skus = [], retailPrices = [], mrps = [], imageUrls = [], urls = [];

		visibleItems.forEach((el) => {
			variantIds.push(el.getAttribute('data-variant-id'));
			names.push(el.getAttribute('data-product-name'));
			prices.push(el.getAttribute('data-frequentprice'));
			skus.push(el.getAttribute('data-product-sku'));
			retailPrices.push(el.getAttribute('data-price'));
			mrps.push(el.getAttribute('data-product-compare-at-price'));
			imageUrls.push(el.getAttribute('data-imageUrl'));
			urls.push(el.getAttribute('data-product-url'));
		});

		const items = variantIds.map((id, i) => ({
			id, name: names[i], price: prices[i], quantity: 1,
		}));

		const formData = {
			items,
			sections: 'cart-drawer,cart-icon-bubble',
			sections_url: '/cart',
		};

		fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(formData),
		})
			.then(res => res.json())
			.then(data => {
				const drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

				if (drawer?.classList.contains('is-empty')) {
					drawer.classList.remove('is-empty');
				}

				drawer.renderContents(data);

				const productTitle = document.querySelector('.product__title h1')?.textContent || '';
				const MRP = this.querySelector('.frequent-originalPrice')?.innerHTML;
				const Offer = this.querySelector('.frequent-offerPrice')?.innerHTML;

				const eventData = {
					event: "frequentlyAddToCart",
					Product_Names: names.join(','),
					Product_ids: variantIds.join(','),
					Qty: 1,
					MRP,
					Offer_Price: Offer,
					Main_Product_name: productTitle,
					clevertap: {
						Product_Names: names.join(','),
						Product_ids: variantIds.join(','),
						Qty: 1,
						MRP,
						Offer_Price: Offer,
						Main_Product_name: productTitle
					}
				};

				window.dataLayer?.push(eventData);

				// shipping bar logic
				setTimeout(() => {
					const shippingBar = document.querySelector('.shipping-bar__filled');
					if (shippingBar) {
						const progress = shippingBar.getAttribute('data-progress');
						fetch('/cart.js')
							.then(res => res.json())
							.then(cart => {
								const shippingEvent = {
									event: 'shippingBarProgress',
									GoalMsg: document.querySelector('.cart-quantity-mssg')?.textContent.trim(),
									CartQty: cart.item_count,
									shippingBarProgressValue: progress,
									cartValue: cart.total_price / 100,
									clevertap: {
										GoalMsg: document.querySelector('.cart-quantity-mssg')?.textContent.trim(),
										CartQty: cart.item_count,
										shippingBarProgressValue: progress,
										cartValue: cart.total_price / 100
									}
								};
								window.dataLayer?.push(shippingEvent);
							});
					}
				}, 1000);
			

				if (frequentCartDrawerElement.classList.contains('is-empty')) {
					frequentCartDrawerElement.classList.remove('is-empty');
				}
				frequentCartDrawerElement.renderContents(data);
				const clevertapData = {
					Product_Names : productNameArray.join(','),
					Product_ids : productIdArray.join(','),
					Qty : 1,
					MRP : document.querySelector(".frequent-Container .frequent-originalPrice").innerHTML,
					Offer_Price : document.querySelector(".frequent-Container .frequent-offerPrice").innerHTML,
					Main_Product_name : document.querySelector(".product__title h1").innerHTML,
				};
				dataLayer.push({
					event: "frequentlyAddToCart",
					Product_Names : productNameArray.join(','),
					Product_ids : productIdArray.join(','),
					Qty : 1,
					MRP : document.querySelector(".frequent-Container .frequent-originalPrice").innerHTML,
					Offer_Price : document.querySelector(".frequent-Container .frequent-offerPrice").innerHTML,
					Main_Product_name : document.querySelector(".product__title h1").innerHTML,
					clevertap : clevertapData
				  });
			})
			.catch((error) => {
				console.error('Error:', error);
			})
      .finally(() => {
				if (typeof swiperCart === 'function') swiperCart();
			});
	}
}

customElements.define('frequently-bought', FrequentlyBought);
